import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeftMedium = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.974 23.6099L11.526 18.0039H29.04V14.0039L11.526 14.0039L16.974 8.3999L14.104 5.6099L4.00404 16.0039L14.104 26.3999L16.974 23.6099Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgArrowLeftMedium);
export { ForwardRef as ReactComponent };
